// Global auth wiring: attach the JWT to every backend call (axios + fetch) and,
// on a 401, clear the session and bounce to login. Imported once in index.tsx.

import axios from "axios";

const TOKEN_KEY = "token";

const getToken = (): string | null => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

const onUnauthorized = (): void => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
  // Full reload to the login route; guard avoids a redirect loop if already there.
  if (window.location.pathname !== "/") {
    window.location.assign("/");
  }
};

// --- axios: inject token on request, catch 401 on response ---
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) onUnauthorized();
    return Promise.reject(error);
  }
);

// --- fetch: wrap to inject the token + catch 401 ---
const originalFetch = window.fetch.bind(window);
window.fetch = async (input: RequestInfo | URL, init: RequestInit = {}) => {
  const token = getToken();
  if (token) {
    const headers = new Headers(init.headers || {});
    if (!headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    init = { ...init, headers };
  }
  const response = await originalFetch(input as any, init);
  if (response.status === 401) onUnauthorized();
  return response;
};

export {};
